module.exports = __webpack_public_path__ + "static/media/interior5.6292d59d.svg";